import { ACCESS_TOKEN_KEY } from "../Constants";

export const getRequestHeaders = (method, body) => {
  const requestHeader = {
    ACCESS_TOKEN: JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY))
      .accessToken,
  };
  if (method.toLowerCase() === "get") {
    const request = {
      method: "GET",
      headers: requestHeader,
    };
    return request;
  } else if (method.toLowerCase() === "post") {
    const request = {
      method: "POST",
      headers: {
        ...requestHeader,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    return request;
  } else {
    throw new Error("Invalid method type");
  }
};
